import { gsap } from 'gsap';

const initTabsVerticalImage = () => {
    const blocks = document.querySelectorAll('.tabs-vertical-image-block');

    blocks.forEach(block => {
        const navItems = block.querySelectorAll('.tab-item');
        const images = block.querySelectorAll('.tab-image-item');
        const contents = block.querySelectorAll('.tab-content-item');
        const circle = block.querySelector('.active-circle');
        const navWrapper = block.querySelector('.tabs-nav-wrapper');

        if (!navItems.length || !circle) return;

        const updateCirclePosition = (targetItem) => {
            // Calculate position relative to the wrapper
            // We use offsetTop of the item relative to the UL, plus UL offset relative to wrapper if any.
            // Assuming wrapper is the offset parent for the circle.
            
            const itemCenter = targetItem.offsetTop + (targetItem.offsetHeight / 2);
            const circleHeight = circle.offsetHeight;
            const targetTop = itemCenter - (circleHeight / 2);

            circle.style.top = `${targetTop}px`;
        };

        const setActive = (index) => {
            // Nav Items
            navItems.forEach(item => item.classList.remove('active'));
            navItems[index].classList.add('active');

            // Circle
            updateCirclePosition(navItems[index]);

            // Images
            images.forEach(img => img.classList.remove('active'));
            if (images[index]) {
                images[index].classList.add('active');
                // Optional: GSAP animation for image
                gsap.fromTo(images[index], 
                    { opacity: 0, y: 20 }, 
                    { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }
                );
            }

            // Content
            contents.forEach(content => content.classList.remove('active'));
            if (contents[index]) {
                contents[index].classList.add('active');
            }
        };

        // Event Listeners
        navItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                setActive(index);
            });
        });

        // Initial set
        // Wait for layout to be stable (images loaded etc, though text height matters more)
        // Using requestAnimationFrame or setTimeout to ensure styles are applied
        setTimeout(() => {
            setActive(0);
        }, 100);

        // Resize observer to update circle position
        const resizeObserver = new ResizeObserver(() => {
            const activeItem = block.querySelector('.tab-item.active');
            if (activeItem) {
                updateCirclePosition(activeItem);
            }
        });
        
        resizeObserver.observe(navWrapper);
    });
};

export default initTabsVerticalImage;
